import SemanticLanding from "@/components/SemanticLanding";

const ImoveisLuxoLagoa = () => (
  <SemanticLanding
    h1="Imóveis de Luxo na Lagoa Rodrigo de Freitas"
    slug="imoveis-de-luxo-na-lagoa"
    metaDescription="Apartamentos e coberturas de luxo na Lagoa Rodrigo de Freitas — vista privilegiada, alto padrão, valorização histórica. Portfólio exclusivo TopClass Imóveis."
    keywords="Imóveis de luxo Lagoa, Apartamentos Lagoa Rodrigo de Freitas, Coberturas Lagoa RJ, Alto padrão Lagoa, Imóveis vista Lagoa, TopClass Imóveis Lagoa"
    intro="Um dos endereços mais desejados do Rio: vista para a Lagoa e para o Corcovado, silêncio, área verde e proximidade de Ipanema, Leblon, Jardim Botânico e Gávea."
    sections={[
      {
        title: "Por que a Lagoa é o endereço mais valorizado do Rio",
        body:
          "A Lagoa Rodrigo de Freitas combina exclusividade, natureza e mobilidade. Cercada por Ipanema, Leblon, Jardim Botânico, Gávea e Humaitá, oferece imóveis com vistas privilegiadas, acesso rápido às praias e às escolas mais tradicionais da cidade. Restaurantes premiados, quiosques na orla, ciclovia de 7,5 km, remo, stand-up paddle — a região atrai famílias de alto padrão que buscam qualidade de vida sem abrir mão da vida urbana.",
      },
      {
        title: "Perfil dos imóveis",
        body:
          "Predominam apartamentos amplos de 3 a 5 quartos, coberturas duplex com piscina privativa e imóveis históricos totalmente reformados. A metragem média está entre 150 e 400 m². Os edifícios geralmente têm poucas unidades por andar, portaria 24h, garagem, e alguns oferecem lazer completo (piscina, academia, salão de festas).",
      },
      {
        title: "Valorização e liquidez",
        body:
          "Imóveis na Lagoa apresentam uma das maiores liquidez do Rio e resistência a ciclos de baixa. A valorização de médio e longo prazo é sustentada pela oferta limitada (não há terrenos para novos lançamentos), pelo tombamento paisagístico que preserva a vista e pela demanda constante de compradores brasileiros e estrangeiros.",
      },
      {
        title: "Nossa curadoria",
        body:
          "A TopClass Imóveis seleciona pessoalmente cada imóvel de luxo na Lagoa: analisamos vista, andar, orientação solar (sol da manhã ou sol da tarde), qualidade da reforma, documentação impecável e histórico do condomínio. Acompanhamos toda a negociação, financiamento e transferência.",
      },
    ]}
    filters={{
      neighborhood: "Lagoa",
      price_min: 3000000,
    }}
    whatsappMessage="Olá! Quero conhecer imóveis de luxo à venda na Lagoa Rodrigo de Freitas."
    faq={[
      {
        question: "Quais tipos de imóveis de luxo estão disponíveis na Lagoa?",
        answer:
          "Apartamentos de 3, 4 e 5 quartos, coberturas duplex, garden apartments e imóveis históricos reformados. Vistas voltadas para a Lagoa, Corcovado ou Cristo Redentor.",
      },
      {
        question: "Qual a faixa de preço na Lagoa?",
        answer:
          "Imóveis de alto padrão na Lagoa geralmente partem de R$ 3 milhões e podem chegar a mais de R$ 30 milhões nas coberturas com vista frontal para a lâmina d'água.",
      },
      {
        question: "A Lagoa é boa para famílias?",
        answer:
          "Sim. A região concentra escolas de referência (Britânica, PACE, São Paulo, San Pablo), fácil acesso a Ipanema e Leblon, área verde e segurança elevada — atributos muito valorizados por famílias.",
      },
      {
        question: "É possível financiar imóveis de luxo na Lagoa?",
        answer:
          "Sim. Trabalhamos com os principais bancos e assessoramos toda a análise de crédito, avaliação bancária, ITBI e registro. Oferecemos também simulação personalizada.",
      },
      {
        question: "Como conhecer os imóveis disponíveis?",
        answer:
          "Fale no WhatsApp para agendar uma visita presencial ou tour virtual. Muitos imóveis de luxo têm restrição de divulgação — enviamos o portfólio completo diretamente para você.",
      },
    ]}
  />
);

export default ImoveisLuxoLagoa;
